import React from 'react';
import classnames from 'classnames';
import classNames from 'classnames';

const MsBoxComp2 = ({
  isPdfRenderMode,
  data,
  limitHeightBox,
  onDownloadLinkClick,
}) => {
  const {
    titre_box,
    bas_de_box,
    // vc,
    // information,
    metric_commune,
    metric_epci,
    download_link,
    download_link_text,
  } = data;

  return (
    <div
      className={classnames(
        { 'h-auto': !isPdfRenderMode && !limitHeightBox },
        { 'h-44': limitHeightBox && !isPdfRenderMode },
        'px-4 py-2 bg-white shadow rounded-lg overflow-hidden border-2 border-gray-300 col-span-1'
      )}
    >
      <div className="grid grid-cols-2 h-full justify-between gap-y-4">
        <div
          className={classnames('col-span-2 font-bold', {
            'text-base': isPdfRenderMode,
            'text-xs 2xl:text-base': !isPdfRenderMode,
          })}
        >
          {titre_box}
        </div>
        <div className="col-span-1">
          <dt
            className={classnames(
              {
                'text-xl': isPdfRenderMode,
                'text-xs 2xl:text-xl': !isPdfRenderMode,
              },
              'font-semibold text-gray-900'
            )}
          >
            {metric_commune || '--'}
          </dt>
          <dd
            className={classNames(
              {
                'text-base': isPdfRenderMode,
                'text-tiny 2xl:text-base': !isPdfRenderMode,
              },
              'mt-1 font-semibold text-gray-700'
            )}
          >
            COMMUNE
          </dd>
        </div>
        <div className="col-span-1 flex flex-col justify-end items-end">
          <dt
            className={classnames(
              {
                'text-xl': isPdfRenderMode,
                'text-tiny 2xl:text-xl': !isPdfRenderMode,
              },
              'font-semibold text-gray-900'
            )}
          >
            {metric_epci || '--'}
          </dt>
          <dd
            className={classNames(
              {
                'text-base': isPdfRenderMode,
                'text-tiny 2xl:text-base': !isPdfRenderMode,
              },
              'mt-1 font-semibold text-gray-700'
            )}
          >
            EPCI
          </dd>
        </div>
        <div
          className={classnames(
            {
              'text-tiny 2xl:text-sm': !isPdfRenderMode,
              'text-sm': isPdfRenderMode,
            },
            'col-span-2 font-medium text-gray-500 flex justify-between flex-nowrap items-end gap-x-4'
          )}
        >
          <span>{bas_de_box?.trim()?.length ? bas_de_box : '--'}</span>
          {download_link && download_link_text && !isPdfRenderMode && (
            <a
              href={download_link}
              className="text-tiny xl:text-xs inline-block overflow-ellipsis cursor-pointer text-blue-500 hover:underline"
              download={download_link_text}
              onClick={(e) => {
                if (isPlu) {
                  e.preventDefault();
                  onDownloadLinkClick();
                }
              }}
              target="_blank"
              rel="noopener noreferrer"
            >
              {download_link_text}
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default MsBoxComp2;
